
/* START_TEMPLATE */
define('hbs!app/templates/contribution',['hbs','Handlebars', 'hbs!app/templates/_rows','app/templates/_helpers/subview'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var stack1, buffer = "<div class=\"at-recurring\">";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.includeFrequencyPlaceholder : depth0), {"name":"if","hash":{},"fn":this.program(2, data),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  stack1 = helpers.each.call(depth0, (depth0 != null ? depth0.recurring : depth0), {"name":"each","hash":{},"fn":this.program(4, data),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "</div>";
},"2":function(depth0,helpers,partials,data) {
  return "<label class=\"at-recurring-frequency\"></label>";
  },"4":function(depth0,helpers,partials,data) {
  var stack1, helperMissing=helpers.helperMissing, buffer = "";
  stack1 = ((helpers.subview || (depth0 && depth0.subview) || helperMissing).call(depth0, depth0, {"name":"subview","hash":{}}));
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"6":function(depth0,helpers,partials,data) {
  var stack1, lambda=this.lambda, escapeExpression=this.escapeExpression;
  return "    <div name=\"AmountSubtitle\" class=\"at-subtitle\">\n      "
    + escapeExpression(lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.resources : depth0)) != null ? stack1.PrimaryResources : stack1)) != null ? stack1.ContributionAcceptedIn : stack1), depth0))
    + " <b>"
    + escapeExpression(lambda(((stack1 = (depth0 != null ? depth0.currency : depth0)) != null ? stack1.code : stack1), depth0))
    + " "
    + escapeExpression(lambda(((stack1 = (depth0 != null ? depth0.currency : depth0)) != null ? stack1.symbol : stack1), depth0))
    + " - "
    + escapeExpression(lambda(((stack1 = (depth0 != null ? depth0.currency : depth0)) != null ? stack1.name : stack1), depth0))
    + "</b>\n    </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, buffer = "<legend class=\"at-legend\">"
    + escapeExpression(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"title","hash":{}}) : helper)))
    + "</legend>\n<div class=\"at-fields\">\n";
  stack1 = this.invokePartial(partials['./_rows'], '  ', './_rows', depth0, undefined, helpers, partials);
  if (stack1 != null) { buffer += stack1; }
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.recurring : depth0), {"name":"if","hash":{},"fn":this.program(1, data),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  stack1 = helpers.each.call(depth0, (depth0 != null ? depth0.afterRecurring : depth0), {"name":"each","hash":{},"fn":this.program(4, data),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.showCurrencyNote : depth0), {"name":"if","hash":{},"fn":this.program(6, data),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "</div>\n";
},"usePartial":true});
Handlebars.registerPartial('app/templates/contribution', t);
return t;
});
/* END_TEMPLATE */
;
